'use strict';


const config = require('app-config');
if (!config) {
	throw new Error('Unable to start: no configuration given!');
}


/**
 * @module helpers/configuration
 * @class ConfigurationHelper
 * @author Sebastian Pekarek
 */
module.exports = class ConfigurationHelper {
	static getRootPath () {
		return '/' + config.language + '/';
	}

	static getBuildId () {
		return config.version.build;
	}

	static getVersion () {
		return config.version.name;
	}

	static getBuildCommit () {
		return config.version.commit;
	}

	static getBuildEnvironment () {
		return config.version.environment;
	}

	static getCurrentLanguage () {
		return config.language;
	}

	static getOtherLanguages () {
		return config.otherLanguages;
	}

	static getStrings () {
		return config.strings;
	}

	static getString (key, replacements) {
		let string = config.strings[key] || '';
		Object.entries(replacements || {}).forEach(([key, value]) => {
			string = string.replace('{{' + key + '}}', value);
		});

		return string;
	}

	static getSentryDSN () {
		return config.sentry.dsn;
	}

	static getGoogleMapsCenter () {
		return config.googleMaps.center;
	}

	static getGoogleMapsZoom () {
		return config.googleMaps.zoom;
	}
	
	static getGoogleMapsBounds () {
		return config.googleMaps.bounds || null;
	}

	static getGoogleMapsStyle () {
		return config.googleMaps.style;
	}
	
	static getAutoCompletionCountries () {
		return config.googleMaps.autoCompletionCountries;
	}

	static getMarkerColor () {
		return config.app.markerColor;
	}
	
	static getFreefloaterColor () {
		return config.app.freefloaterColor || config.app.markerColor;
	}

	static getCustomMarkerConfig (type) {
		return config.app.markers[type] || null;
	}
	
	static getPolygonColor () {
		return config.googleMaps.polyColor || null;
	}

	static getTopCityThreshold () {
		return config.app.topCityThreshold || Infinity;
	}
	
	static getMaxPlacesInList () {
		return config.app.maxPlacesInList || 25;
	}
	
	static getBookingUrl ({place, bookee}) {
		if (!config.app.bookingUrl) { return null; }
		
		let bookingUrl = config.app.bookingUrl;
		if (place) { // could be a place or a place of a freefloater
			bookingUrl = bookingUrl + '?location.lat=' +
				(place.lat || place.geoCoordinate.latitude) +
				'&location.lng=' +
				(place.lng || place.geoCoordinate.longitude);
		}
		
		if (bookee && place) { // has to be first, b.c. if freeFlaoter, place and bookee are the options
			return bookingUrl + '&openBookee=' + bookee.id;
		}
		
		if (bookee) {
			return bookingUrl + '?openBookee=' + bookee.id;
		}
		
		if (place) {
			return bookingUrl + '&openPlace=' + place.id;
		}
		
		return config.app.bookingUrl;
	}
	
	static openMarkerDirectly () {
		return config.app.openMarkerDirectly || false;
	}
};
